<div fxFlex class="common-textarea-box" [ngClass]="{
  'nr-err-border': formGroup.get(formControlFieldName).touched && formGroup.get(formControlFieldName).hasError('required')
  }">
  <div class="container-textarea" fxLayout="column">
    <div fxLayout="row">
      <textarea class="textarea-input" trimSpace cdkTextareaAutosize #autosize="cdkTextareaAutosize"
        [cdkAutosizeMinRows]="mnRows" [cdkAutosizeMaxRows]="mxRows" maxlength="{{mxLength}}"
        id="{{formControlFieldName}}" formControlName="{{formControlFieldName}}" placeholder="{{placeholder}}">
	    </textarea>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <div class="count-text"> {{displayRemain}} characters left </div>
    </div>
  </div>
</div>